import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Badge from "@mui/material/Badge";
import type {FilterRule} from "crqlar-react-common/dist/models/audience/filter.model";
import type {FilterOption} from "crqlar-react-common/dist/models/audience/filterOption.model";
import {useTranslation} from "react-i18next";
import FilterPanel from "../../common/serverTable/components/FilterPanel";
import {RightSidebarFloatingPanel} from "../../layout/rightSidebar/RightSidebarFloatingPanel";
import {RightSidebarPanelButton} from "../../layout/rightSidebar/RightSidebarRail";

interface DailyListFilterButtonProps {
    filterOptions: FilterOption[];
    rules: FilterRule[];
    onChange: (rules: FilterRule[]) => void;
}

export default function DailyListFilterButton({
    filterOptions,
    rules,
    onChange,
}: DailyListFilterButtonProps) {
    const {t} = useTranslation();

    return (
        <RightSidebarPanelButton
            icon={(
                <Badge color="primary" badgeContent={rules.length}>
                    <FilterAltOutlinedIcon/>
                </Badge>
            )}
            label={t("Filter")}
            renderPanel={close => (
                <RightSidebarFloatingPanel>
                    <FilterPanel
                        filterOptions={filterOptions}
                        rules={rules}
                        onChange={onChange}
                        onClose={close}
                    />
                </RightSidebarFloatingPanel>
            )}
        />
    );
}
